// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypesResourceStatus } from './TypesResourceStatus';
import {
  TypesResourceStatusFromJSON,
  TypesResourceStatusFromJSONTyped,
  TypesResourceStatusToJSON,
  TypesResourceStatusToJSONTyped,
} from './TypesResourceStatus';

/**
 *
 * @export
 * @interface TypesClusterMetadata
 */
export interface TypesClusterMetadata {
  /**
   *
   * @type {string}
   * @memberof TypesClusterMetadata
   */
  clusterId?: string;
  /**
   *
   * @type {string}
   * @memberof TypesClusterMetadata
   */
  clusterSpec?: string;
  /**
   *
   * @type {string}
   * @memberof TypesClusterMetadata
   */
  neo4jConfiguration?: string;
  /**
   *
   * @type {string}
   * @memberof TypesClusterMetadata
   */
  orchestra?: string;
  /**
   *
   * @type {TypesResourceStatus}
   * @memberof TypesClusterMetadata
   */
  status?: TypesResourceStatus;
}

/**
 * Check if a given object implements the TypesClusterMetadata interface.
 */
export function instanceOfTypesClusterMetadata(
  value: object,
): value is TypesClusterMetadata {
  return true;
}

export function TypesClusterMetadataFromJSON(json: any): TypesClusterMetadata {
  return TypesClusterMetadataFromJSONTyped(json, false);
}

export function TypesClusterMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesClusterMetadata {
  if (json == null) {
    return json;
  }
  return {
    clusterId: json['ClusterId'] == null ? undefined : json['ClusterId'],
    clusterSpec: json['ClusterSpec'] == null ? undefined : json['ClusterSpec'],
    neo4jConfiguration:
      json['Neo4jConfiguration'] == null
        ? undefined
        : json['Neo4jConfiguration'],
    orchestra: json['Orchestra'] == null ? undefined : json['Orchestra'],
    status:
      json['Status'] == null
        ? undefined
        : TypesResourceStatusFromJSON(json['Status']),
  };
}

export function TypesClusterMetadataToJSON(json: any): TypesClusterMetadata {
  return TypesClusterMetadataToJSONTyped(json, false);
}

export function TypesClusterMetadataToJSONTyped(
  value?: TypesClusterMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ClusterId: value['clusterId'],
    ClusterSpec: value['clusterSpec'],
    Neo4jConfiguration: value['neo4jConfiguration'],
    Orchestra: value['orchestra'],
    Status: TypesResourceStatusToJSON(value['status']),
  };
}
